import { Iteration } from '../../../schemas/Iteration.schema';
import { IterationRule } from '../../../schemas/IterationRule.schema';
import { getRulesDisplay, reduceRulesWithAndClauses } from '../../../utils/ruleUtils';
import { SECTIONS } from '../Constants';

export interface RuleData {
    Name: string;
    checked: boolean;
    primarykey: string;
    iterationRule: IterationRule;
}

const useRulesData = (
  iteration: Iteration,
  filterRulesCheckedItems: Record<string, boolean>,
  suppressionRulesCheckedItems: Record<string, boolean>,
  routingRulesCheckedItems: Record<string, boolean>,
) => {
  const getRulesData = (
    checkedItems: Record<string, boolean>,
    type: string,
    label: string,
    checkBoxName: string,
  ) => {
    const rules = iteration?.IterationRules?.filter((rule) => rule.Type === type) || [];

    const rulesWithAndClauses = rules.reduce(reduceRulesWithAndClauses, []);

    const displayRules = getRulesDisplay(iteration, rulesWithAndClauses);

    return {
      rules: displayRules.map((rule, idx) => ({
        Name: rule.DisplayName || '',
        checked: checkedItems[`rule-${rule.Type}-${idx}`] || false,
        primarykey: `rule-${rule.Type}-${idx}`,
        iterationRule: rule,
      })),
      label,
      ariaLabel: label,
      disabled: rules.length === 0,
      checkBoxName,
    };
  };

  const filterRules = getRulesData(
    filterRulesCheckedItems,
    'F',
    'Filter rules',
    SECTIONS.FILTER_RULES,
  );
  const suppressionRules = getRulesData(
    suppressionRulesCheckedItems,
    'S',
    'Suppression rules',
    SECTIONS.SUPPRESSION_RULES,
  );

  const routingRules = getRulesData(
    routingRulesCheckedItems,
    'R',
    'Routing rules',
    SECTIONS.ROUTING_RULES,
  );

  return [filterRules, suppressionRules, routingRules];
};

export default useRulesData;
